<template>
  <AbstractCourseBadge class="taxi-course-badge" text="serwis" />
</template>

<script>
import AbstractCourseBadge from './abstract-course-badge';

export default {
  name: 'ServiceCourseBadge',
  components: {
    AbstractCourseBadge,
  },
};
</script>

<style lang="scss" scoped>
@use '@/core/style/global.scss' as *;

.taxi-course-badge {
  @include course-badge(var(--service-course-badge-color), var(--service-course-badge-text-color));
}
</style>
